import React from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import I18N from '@leverege/i18n';
import { DataSources } from '@leverege/ui-attributes';
import { Flex, Text } from '@leverege/ui-elements';
import { Toolbar } from '@leverege/ui-plugin';
import S from './RefreshLocationCacheDetailRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.details.refreshLocationCache.RefreshLocationCacheDetailRenderer');
const EMPTY = {};
const client = 'DataCardDetail';
export default class RefreshLocationCacheDetailRenderer {
  constructor(model) {
    this.model = model;
  }
  getValueComponent(object, cxt, ...rest) {
    const {
      type
    } = object;
    const context = {
      ...cxt,
      client
    };
    const matchContext = {
      use: 'actionBar',
      objectType: type,
      client
    };
    return /*#__PURE__*/_jsx(ManagedValueComponent, {
      locationObjRef: object,
      context: context,
      matchContext: matchContext,
      model: this.model
    }, object?.id);
  }
  getComponents(object, cxt = EMPTY, ...rest) {
    return [{
      style: {
        padding: '0px'
      },
      component: this.getValueComponent(object, cxt)
    }];
  }
}
function LocationCacheRefresh({
  locationId,
  context,
  matchContext,
  model
}) {
  const lastRefreshed = context.target[0]?.data?.data?.lastRefreshed;
  const keysEnabled = context.target[0]?.data?.data?.keysEnabled;
  let valueToDisplay;
  if (!keysEnabled) {
    valueToDisplay = t('notEnabled');
  } else if (lastRefreshed) {
    const date = new Date(lastRefreshed);
    valueToDisplay = !Number.isNaN(date.getTime()) ? format(date, 'M/d h:mm a') : t('noRefreshedValue');
  } else {
    valueToDisplay = t('noRefreshedValue');
  }
  return /*#__PURE__*/_jsxs(Flex, {
    className: S.row,
    style: model.style,
    align: "center",
    justify: "space-between",
    variant: "detail",
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "detailLabel",
      children: t('title')
    }), valueToDisplay || t('noRefreshedValue'), /*#__PURE__*/_jsx(Toolbar, {
      variant: "secondary",
      context: context,
      matchContext: matchContext
    })]
  });
}
function ManagedValueComponent({
  locationObjRef,
  context,
  matchContext,
  model
}) {
  const delegate = DataSources.getDelegate(locationObjRef);
  const location = useSelector(state => delegate.getItem(state));
  const locationId = location?.data?.locationId || location?.id;
  return /*#__PURE__*/_jsx(LocationCacheRefresh, {
    locationId: locationId,
    context: context,
    matchContext: matchContext,
    model: model
  });
}